import { Reservation } from "../../types/common.types";

// Al cambiarle la fecha o el tour a un pasajero de un privado se mueve el auto completo (lo hace el
// backend en editReservation). Este aviso aparece en el formulario apenas se cambia, antes de guardar,
// y pregunta si el trip se mueve con el auto.
interface Props {
    vehiculo: Reservation['vehiculo']
    cambio: boolean
    mismoTour: boolean
    moverTrip: boolean
    setMoverTrip: (value: boolean) => void
}

const caja = { margin: '10px 0', padding: '8px 10px', borderRadius: '6px', fontSize: '14px', lineHeight: 1.45 }

export default function AvisoMoverPrivado({ vehiculo, cambio, mismoTour, moverTrip, setMoverTrip }: Props) {
    if (!vehiculo || !cambio || vehiculo.pasajeros <= 1 && !vehiculo.trip) return null
    const trip = vehiculo.trip
    if (trip?.otra_agencia || trip?.cerrado) {
        return (
            <p style={{...caja, backgroundColor: '#fee2e2', color: '#991b1b'}}>
                {trip.otra_agencia
                    ? `Este privado está traspasado a ${trip.otra_agencia}: resuélvelo en Traspasos antes de cambiarle la fecha.`
                    : 'El trip de este privado ya está cerrado: no se le puede cambiar la fecha.'}
            </p>
        )
    }
    return (
        <div style={{...caja, backgroundColor: '#fef3c7', color: '#92400e'}}>
            <p style={{margin: 0}}>
                Vas a mover el privado completo: {vehiculo.nombres?.join(', ')} pasan a la nueva fecha, con su precio y sus pagos.
                Si solo cambia uno, cancela y sácalo primero del grupo.
            </p>
            {
                trip && (trip.exclusivo && mismoTour
                    ? <label style={{display: 'flex', gap: '8px', marginTop: '8px', cursor: 'pointer'}}>
                        <input type="checkbox" checked={moverTrip} onChange={e => setMoverTrip(e.target.checked)}/>
                        <span>Mover también su trip{trip.hora ? ` de las ${trip.hora}` : ''} (guía, chofer y auto) a la nueva fecha. Si no, queda sin trip y se asigna en la nueva fecha.</span>
                    </label>
                    : <p style={{margin: '8px 0 0'}}>
                        {mismoTour
                            ? 'Su trip tiene otros pasajeros: el privado queda sin trip en la nueva fecha y se asigna ahí.'
                            : 'Al cambiar de tour, el privado queda sin trip y se asigna en el tour nuevo.'}
                    </p>)
            }
        </div>
    )
}
